export const USER_RESOURCE = { key: 'USER_RESOURCE' };
